import { jsx } from 'react/jsx-runtime';
import { createContext, useMemo, useContext } from 'react';
import { DEFAULT_EXTERNAL_ROUTES } from '../config/routes.esm.js';
import { getRoutesForClient } from '../helpers/routes.esm.js';
import { useI18nContext } from './I18nProvider.esm.js';

/* istanbul ignore next */ var NavContext = /*#__PURE__*/ createContext({
    nav: {
        host: ""
    }
});
var NavProvider = function(param) {
    var _param_baseUrl = param.baseUrl, baseUrl = _param_baseUrl === void 0 ? "" : _param_baseUrl, _param_internalPages = param.internalPages, internalPages = _param_internalPages === void 0 ? [] : _param_internalPages, _param_externalPages = param.externalPages, externalPages = _param_externalPages === void 0 ? DEFAULT_EXTERNAL_ROUTES : _param_externalPages, children = param.children;
    var _useI18nContext = useI18nContext(), lang = _useI18nContext.lang, region = _useI18nContext.region;
    var value = useMemo(function() {
        return {
            nav: getRoutesForClient(region, lang, baseUrl, internalPages, externalPages)
        };
    }, [
        region,
        lang,
        baseUrl,
        internalPages,
        externalPages
    ]);
    return /*#__PURE__*/ jsx(NavContext.Provider, {
        value: value,
        children: children
    });
};
function useNavContext() {
    return useContext(NavContext);
}

export { NavContext, NavProvider, useNavContext };
